import request from "@/http";
/**
 * 获取用户订单
 * @param {} data
 * @returns
 */
const getList = (data) => {
  //200002: 充值订单; 300003: 项目订单; 400004: 分销订单;
  let {
    begin_idx,
    limit,
    type_order_4_application,
    id_public_user_info,
    isloading = false,
    type_order = 1,
  } = data;
  return request.get({
    url: "duzikai_api_customer_public_statistic_mgr",
    data: {
      invoke_method: "order_list_4_one_user",
      type_order: type_order,
      pre_db_para_begin_idx: begin_idx,
      pre_db_para_length_4_list: limit,
      type_order_4_application: type_order_4_application,
      pre_cmd_para_show_info_append: "show_detail_info",
      buyer_id: id_public_user_info,
      pre_db_para_order_by_para: ' time_update desc ',
      ship_state: "1,4",
    },
    loading: {
      enabled: isloading,
    },
  });
};

export default {
  getList,
};
